/** Demo list: use API ids when present, otherwise synthesize sequential ILPNs for the row count. */
export function resolveIlpnIdsForRow(row) {
  const total = row.totalILPNs ?? 0;
  if (total <= 0) {
    return [];
  }
  const existing = row.ilpnIds || [];
  if (existing.length >= total) {
    return existing.slice(0, total);
  }
  const seedMatch = existing[0]?.match(/(\d+)$/);
  const startNum = seedMatch
    ? parseInt(seedMatch[1], 10)
    : 1038600 + (row.palletGroup?.length || 0);
  return Array.from({ length: total }, (_, index) => {
    const num = startNum + index;
    return `IL${String(num).padStart(10, "0")}`;
  });
}
